import { cn } from "@/lib/utils";

export type HubBadgeKind = "new" | "ai" | "beta";

export function HubBadge({ kind }: { kind: HubBadgeKind }) {
  const text = kind === "ai" ? "AI" : kind === "new" ? "New" : "Beta";
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-1.5 py-px font-mono text-[8.5px] uppercase tracking-[0.18em]",
        kind === "ai" && "border-accent/45 bg-accent/15 text-accent",
        kind === "new" &&
          "border-[hsl(var(--success)/0.45)] bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))]",
        kind === "beta" &&
          "border-[hsl(var(--warning)/0.45)] bg-[hsl(var(--warning)/0.12)] text-[hsl(var(--warning))]",
      )}
    >
      {text}
    </span>
  );
}
